import { Box, Text } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import MfaWizardStepProgress from './MfaWizardStepProgress';
import { Heading } from 'components/v4';
import { SubmitButton } from '@/v5/components/atoms/Button/SubmitButton';

import { styles } from '@/v5/@constants/login';

export default function MfaWizardStepBodyThree({ step, authResponse }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    return (
        <>
            <Box>
                <MfaWizardStepProgress step={step} />
            </Box>
            <Box padding="20px 0px">
                <Heading as="h2" sx={styles.heading}>
                    Multi Factor Authentication enabled!
                </Heading>
                <Text fontSize="md" sx={{ marginBottom: 3 }} color="black">
                    From now on when you sign, you will need to enter both your
                    password and an authentication code from your authenticator
                    app.
                </Text>
            </Box>

            <Box sx={styles.buttonContainer}>
                <SubmitButton
                    onClick={() => {
                        dispatch({
                            type: 'LOGIN_SUCCESS',
                            payload: {
                                ...authResponse,
                                loadAccessList: true,
                                showMFA: false,
                            },
                        });
                        navigate('/');
                    }}>
                    Finish
                </SubmitButton>
            </Box>
        </>
    );
}
